export default [
  {
    path: '/main/active-status',
    meta: {
      tag: 'list_activestatus',
      name: 'Status de Ativo',
      breadcrumb: 'Status de Ativo'
    },
    component: () => import(/* webpackChunkName: "active-status-list" */ '@/views/main/settings/stock-registers/activeStatus/Index.vue'),
    children: [
      {
        path: '',
        name: 'listactivestatus',
        meta: {
          tag: 'list_activestatus',
          menu: 'settings',
          name: 'Status de Ativo'
        },
        component: () => import(/* webpackChunkName: "active-status-list" */ '@/views/main/settings/stock-registers/activeStatus/List.vue')
      },
      {
        path: '/main/active-status/add',
        name: 'addactivestatus',
        meta: {
          tag: 'add_activestatus',
          menu: 'settings',
          name: 'Adicionar | Status de Ativo',
          breadcrumb: 'Adicionar Status de Ativo'
        },
        component: () => import(/* webpackChunkName: "active-status-add" */ '@/views/main/settings/stock-registers/activeStatus/Add.vue')
      },
      {
        path: '/main/active-status/:id',
        name: 'editactivestatus',
        meta: {
          tag: 'edit_activestatus',
          menu: 'settings',
          name: 'Editar | Status de Ativo',
          breadcrumb: 'Editar Status de Ativo'
        },
        component: () => import(/* webpackChunkName: "active-status-edit" */ '@/views/main/settings/stock-registers/activeStatus/Edit.vue')
      }
    ]
  }
]